import { useCallback, useEffect, useMemo, useReducer } from 'react';
import { useForm } from 'react-hook-form';
import useSend403 from '../../../../modules/game/hooks/use-send-403';
import useTask from '../../../../modules/tasks/hooks/use-task';
import NextButton from '../../../next-button';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task403: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-403');

    useEffect(() => {
        onComplete();
    }, [onComplete]);

    const [inputCount, changeInput] = useReducer((state: { ids: number[], nextId: number }, action: number | null) => {
        if (action === null) {
            return {
                ...state,
                ids: [...state.ids, state.nextId],
                nextId: state.nextId + 1
            }
        }

        return {
            ...state,
            ids: state.ids.filter(v => v !== action)
        }
    }, {
        ids: [0, 1, 2, 3, 4],
        nextId: 5
    });

    const { register, handleSubmit, watch } = useForm();
    const { send, isLoading, isSuccess } = useSend403();

    const onSubmit = useCallback((data) => {
        send(Object.values<string>(data).map(s => s.trim().replace(/ /g, '')).filter(Boolean))
    }, [send]);

    const data = watch();

    const isReadyToSend = useMemo(() => {
        if (isLoading || isSuccess) {
            return false;
        }

        const answers = Object.values<string>(data).map(s => (s || '').trim().replace(/ /g, '')).filter(Boolean);

        return answers.length > 0;
    }, [data, isLoading, isSuccess]);

    return <div className="task task-403">
        <h2>zadanie 3</h2>
        <h3>{task?.title}</h3>
        <div className="poem">
            <figure>
                <blockquote>
                    “Kupiła raz maczku paczkę,<br />
                    By pisać list drobnym maczkiem.<br />
                    Zjadając tasiemkę starą<br />
                    Mówiła, że to makaron,<br />
                    A gdy połknęła dwa złote,<br />
                    Mówiła, że odda potem.”
                </blockquote>
                <figcaption>
                    Jan Brzechwa  “Kaczka dziwaczka”
                </figcaption>
            </figure>
        </div>
        <p>
            Kaczka dziwaczka zasłynęła nietypowym zastosowaniem różnych przedmiotów. Zamiast grzebienia używała wykałaczki, pisała listy makiem… Musicie przyznać, że to dość kreatywne podejście! Myślicie, że Wy dalibyście radę wymyślić, jak można używać różnych przedmiotów w niecodzienny sposób? Na przykład książek?
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Wymyślcie 30 różnych zastosowań dla książek! Propozycje wpisujcie w miejsca poniżej.
        </p>

        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            {
                inputCount.ids.map((id) => {
                    return <div className='row' key={id}>
                        <input type="text" {...register(`input_${id}`)} />
                        <button className='remove-button' onClick={() => { changeInput(id) }} type="button">-</button>
                    </div>
                })
            }
            <div className="buttons">
                <button className="add-button" type="button" onClick={() => { changeInput(null) }}>Dodaj</button>
                {isReadyToSend && <NextButton>Wyślij</NextButton>}
                {isLoading && <p className='send-info'>Wysyłamy</p>}
                {isSuccess && <p className='send-info'>Twoje odpowiedzi zostały wysłane</p>}
            </div>
        </form>
    </div>
}

export default Task403;
